<div class="bulk-review bulk-review--modal d-flex flex-column position-relative">
  <!-- Close Button -->
  <button
    type="button"
    class="bulk-review__close position-absolute"
    style="top: 20px; right: 24px; z-index: 10;"
    (click)="activeModal.dismiss()"
  >
    <i class="fas fa-times text-muted"></i>
  </button>

  <!-- Skeleton Loading State -->
  <ng-container *ngIf="!hasLoaded && (isCountLoading || isLoading)">
    <div class="p-4">
      <div class="bulk-review__header d-flex align-items-center gap-3 mb-2">
        <div class="skeleton" style="width: 44px; height: 44px; border-radius: 12px;"></div>
        <div>
          <div class="skeleton mb-2" style="width: 300px; height: 24px;"></div>
          <div class="skeleton" style="width: 500px; height: 16px;"></div>
        </div>
      </div>

      <div class="bulk-review__summary-section">
        <div class="skeleton mb-3" style="width: 250px; height: 20px;"></div>
        <div class="skeleton mb-2" style="width: 100%; height: 10px; border-radius: 100px;"></div>
        <div class="d-flex gap-4">
          <div class="skeleton" style="width: 200px; height: 14px;"></div>
          <div class="skeleton" style="width: 200px; height: 14px;"></div>
        </div>
      </div>

      <div class="bulk-review__toolbar mb-3">
        <div class="skeleton" style="width: 320px; height: 38px; border-radius: 8px;"></div>
      </div>

      <div class="bulk-review__grid-skeleton border rounded overflow-hidden flex-grow-1">
        <div class="skeleton" style="width: 100%; height: 44px; border-radius: 0;"></div>
        <div class="p-0">
          <div class="skeleton-row border-bottom" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
            <div class="skeleton" style="width: 100%; height: 48px; border-radius: 0; opacity: 0.6;"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Content State -->
  <ng-container *ngIf="hasLoaded || (!isCountLoading && !isLoading)">
    <div class="p-4 flex-grow-1 d-flex flex-column overflow-hidden">
      
      <!-- Header -->
      <div class="bulk-review__header d-flex align-items-center gap-3 mb-2">
        <div class="bulk-review__icon-box" [style.background-color]="actionMeta.color + '15'" [style.color]="actionMeta.color">
          <i [class]="actionMeta.icon"></i>
        </div>
        <div>
          <h3 class="bulk-review__title m-0">Review bulk update</h3>
          <div class="bulk-review__subtitle mt-1">
            Applying <span class="font-weight-bold" [style.color]="actionMeta.color">{{ actionMeta.actionText }}</span> to your selection 
            &middot; <span class="font-weight-bold">{{ totalSkuCount }} SKUs</span> 
            &middot; <span class="font-weight-bold">{{ totalAdCount }} child Ads</span>
          </div>
        </div>
      </div>

      <!-- Summary Section -->
      <div class="bulk-review__summary-section">
        <div class="bulk-review__summary-bar">
          <div class="d-flex align-items-baseline gap-3 mb-3">
            <div class="bulk-review__change-count">
              <span class="bulk-review__highlight-count" [style.color]="actionMeta.color">{{ totalAdWillUpdate }}</span> 
              <span class="bulk-review__change-label">of {{ totalAdCount }} ads will change</span>
            </div>
            <div class="bulk-review__sku-chip" style="color: #3b82f6; background-color: rgba(59, 130, 246, 0.1);">Across {{ totalSkuWillUpdate }} SKUs</div>
          </div>

          <div class="bulk-review__bucket-bar-container">
            <div class="bulk-review__bucket-bar mb-2">
              <div class="bulk-review__segment bulk-review__segment--will-update" [style.background-color]="actionMeta.color" [style.width.%]="bucketBarData.willUpdatePercent"></div>
              <div class="bulk-review__segment bulk-review__segment--no-change" [style.width.%]="bucketBarData.alreadyCurrentPercent"></div>
            </div>
            <div class="bulk-review__legend d-flex gap-4">
              <div class="d-flex align-items-center">
                <span class="bulk-review__square" [style.background-color]="actionMeta.color"></span>
                <span><strong class="text-dark">{{ bucketBarData.willUpdate }}</strong> &middot; {{ bucketBarData.currentState }} <span class="bulk-review__arrow">&rarr;</span> {{ bucketBarData.targetState }}</span>
              </div>
              <div class="d-flex align-items-center">
                <span class="bulk-review__square" style="background: #d1d5db;"></span>
                <span><strong class="text-dark">{{ bucketBarData.alreadyCurrent }}</strong> &middot; {{ bucketBarData.targetState }} <span class="bulk-review__arrow">&rarr;</span> {{ bucketBarData.targetState }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Toolbar -->
      <div class="bulk-review__toolbar mb-3 d-flex align-items-center justify-content-between">
        <div class="bulk-review__search-box">
          <i class="fas fa-search" style="color: #3b82f6;"></i>
          <input
            type="text"
            class="form-control"
            placeholder="Search SKU or campaign..."
            [disabled]="!totalAdWillUpdate"
            [ngModel]="searchTerm"
            (input)="onSearch($event)"
            [style.border-color]="searchTerm ? '#3b82f6' : '#e5e7eb'"
          />
        </div>
      </div>

      <!-- Grid -->
      <div class="bulk-review__grid-container border rounded overflow-hidden shadow-sm">
        <app-forecast-rxtreelist
          [idField]="'id'"
          [columns]="columns"
          [rootItems]="rootItems"
          [totalRootCount]="isSelectAll ? filteredTotal : rootItems.length"
          [levelConfigs]="levelConfigs"
          [loading]="isLoading"
          [disabledCalcGridHeight]="true"
          [showCheckboxColumn]="false"
          [fullScreenIconIsVisible]="false"
          [toogleFullScreenIsVisible]="false"
          [showToolbar]="false"
          [pageSize]="pageSize"
          [skip]="skip"
          (pageChange)="onPageChange($event)"
        >
          <!-- Current State -->
          <ng-template appTreelistCustomCell="currentState" let-dataItem>
            <span class="text-muted">{{ dataItem.currentState }}</span>
          </ng-template>

          <!-- Action Arrow -->
          <ng-template appTreelistCustomCell="rowAction" let-dataItem>
            <div class="d-flex align-items-center justify-content-center w-100">
              <i class="fas fa-arrow-right text-muted" style="opacity: 0.3;"></i>
            </div>
          </ng-template>

          <!-- New State -->
          <ng-template appTreelistCustomCell="newState" let-dataItem>
            <span class="font-weight-bold" style="color: #1a1a1a;">
              {{ dataItem.newState }}
            </span>
          </ng-template>

          <!-- Status Badge -->
          <ng-template appTreelistCustomCell="status" let-dataItem>
            <div class="bulk-review__status-badge" 
              [ngClass]="dataItem.status === 'will-update' ? 'bulk-review__status-badge--will-change' : 'bulk-review__status-badge--no-change'">
              <i *ngIf="dataItem.status === 'will-update'" class="fas fa-sync-alt"></i>
              {{ getStatusLabel(dataItem.status) }}
            </div>
          </ng-template>
        </app-forecast-rxtreelist>
      </div>
    </div>

    <!-- Footer -->
    <div class="bulk-review__footer p-4 bg-light d-flex align-items-center justify-content-between mt-auto">
      <div class="bulk-review__confirm-check custom-control custom-checkbox">
        <ng-container *ngIf="!!totalAdWillUpdate">
          <input type="checkbox" class="custom-control-input" id="confirmCheck" [(ngModel)]="isConfirmed"/>
          <label class="custom-control-label" for="confirmCheck">
            I've reviewed the summary and want to apply 
            <span class="bulk-review__action-text" [style.color]="actionMeta.color">{{ actionMeta.actionText }}</span> 
            to <span class="font-weight-bold">{{ totalAdWillUpdate }}</span> ads.
          </label>
        </ng-container>
      </div>

      <div class="bulk-review__actions d-flex gap-2">
        <button class="btn btn-outline-secondary px-4" (click)="activeModal.dismiss()">Cancel</button>
        <button 
          class="btn btn-primary px-4 font-weight-bold" 
          *ngIf="!!totalAdWillUpdate"
          [disabled]="!isConfirmed || isLoading" 
          (click)="confirm()"
          [style.background-color]="actionMeta.color"
          [style.border-color]="actionMeta.color"
        >
          <ng-container *ngIf="!isLoading">Confirm</ng-container>
          <ng-container *ngIf="isLoading">
            <span class="spinner-border spinner-border-sm mr-2"></span> Applying...
          </ng-container>
        </button>
      </div>
    </div>
  </ng-container>
</div>
